import { useEffect } from 'react';

export function GtmHeadScript(): null {
  useEffect(() => {
    const gtmId = import.meta.env.VITE_GTM_ID;
    const isProduction = import.meta.env.VITE_ENVIRONMENT === 'production';

    if (!isProduction || !gtmId) {
      return;
    }

    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${gtmId}`;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gtmId}');
    `;
    document.head.appendChild(script2);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  return null;
}
